export default __webpack_public_path__ + "static/media/home-imac.6ee6f16a.jpg";